module.exports = __webpack_public_path__ + "img/ReviewDetails_2.1fd907b8.png";